import { appUrl } from "@src/cloud-connect/feature-toggles/feature-toggles";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";
import TokensExpiredError from "../errors/tokens-expired-error";
import { buildAuthenticationHeaders } from "../util/build-authentication-headers";
import { buildAuthenticationBody } from "../util/build-authentication-body";

export const fetchServerLists = (updateServerListsInStoreFunction, signal) => {
  return fetch(`${appUrl()}/api/get-sources`, {
    method: "POST",
    headers: buildAuthenticationHeaders(),
    body: JSON.stringify(buildAuthenticationBody()),
    signal,
  })
    .then(async (res) => {
      if (res.ok) {
        return res.json();
      } else {
        const json = await res.json();
        if (json.message === "Refresh Token is expired") {
          throw new TokensExpiredError("All Tokens Expired");
        } else {
          throw new Error("Server Responded with 500");
        }
      }
    })
    .then((data) => {
      if (data !== undefined) {
        updateServerListsInStoreFunction(data);
      }
    })
    .catch((err) => {
      if (err instanceof TokensExpiredError) {
        navigateTo(Route.TOKENS_EXPIRED_ERROR);
      } else if (err instanceof DOMException) {
        return;
      } else {
        navigateTo(Route.SERVER_ERROR);
      }
    });
};
